import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, emssUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null; // O LoadingOverlay no AuthProvider cuidará do visual
  }

  if (!user) {
    // Redireciona para o login mas salva a localização de onde o usuário tentou vir
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se o jogo prioritário do usuário for o Forza Horizon 6, ele só pode acessar rotas do FH6 (/fh6/*)
  const FH6_GAME_ID = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890';
  const isFh6Priority = emssUser?.priority_game_id === FH6_GAME_ID;
  const isFh6Path = location.pathname.startsWith('/fh6');

  if (isFh6Priority && !isFh6Path) {
    const cleanPath = location.pathname === '/' || location.pathname === '' ? '/console' : location.pathname;
    return <Navigate to={`/fh6${cleanPath}${location.search}`} replace />;
  }

  // Se NÃO é prioridade FH6 mas está em rota FH6, redireciona para o console padrão
  if (!isFh6Priority && isFh6Path) {
    const cleanPath = location.pathname.replace('/fh6', '') || '/console';
    return <Navigate to={`${cleanPath}${location.search}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
